import React, { FC, useState } from 'react';
import Modal from '@components/Modal';
import Button from '@/components/DesignLibrary/Button';
import WarningCircle from '@/components/Icons/WarningCircle';
import { Checkbox } from '@/components/DesignLibrary/Atoms';

import s from './ArchiveWorkflowConfirmationModal.module.scss';

type Props = {
  onConfirm: () => void;
  setIsArchiveWorkflowConfirmationModalOpen: (open: boolean) => void;
  loading: boolean;
};

const data = [
  {
    key: 'attachments',
    label: 'All attachments in the workflow will be archived permanently',
  },
  {
    key: 'tasks',
    label: 'Any pending tasks in the workflow will be deleted',
  },
  {
    key: 'activity',
    label: 'All activity logs related to this workflow will be cleared',
  },
  {
    key: 'paymentPlans',
    label: 'Any active payment plans linked to this workflow will be cancelled.',
  },
  {
    key: 'invoices',
    label: 'All invoices are voided',
  },
];

const ArchiveWorkflowConfirmationModal: FC<Props> = ({ onConfirm, setIsArchiveWorkflowConfirmationModalOpen, loading }) => {
  const [checked, setChecked] = useState<string[]>([]);
  return (
    <Modal hasPadding onClose={() => setIsArchiveWorkflowConfirmationModalOpen(false)} title="">
      <div className={s.modalHeader}>
        <WarningCircle size={96} weight="fill" color="var(--color-warning)" />
        <h2 className="body-lg-bold">You are about to archive a workflow</h2>
        <p className={[s.modalBodyText, s.modalTextWarning].join(' ')}>
          Archiving a workflow will prevent any furhter actions from being taken and will delete information
          that may be important. Proceed with caution.
        </p>
      </div>
      <div className={s.modalBody}>
        <p className={s.modalBodyPleaseCheck}>Please check every item below to acknowledge that:</p>
        <ul className={s.modalBodyCheckList}>
          {data.map(item => (
            <li key={item.key}>
              <Checkbox
                label={item.label}
                isChecked={checked.includes(item.key)}
                onChange={isChecked => {
                  setChecked(prev => (isChecked ? [...prev, item.key] : prev.filter(key => key !== item.key)));
                }}
              />
            </li>
          ))}
        </ul>
        <div className={s.modalBodyButtons}>
          <Button
            size="md"
            className={s.modalBodyButton}
            variant="primary"
            onClick={onConfirm}
            disabled={data.length !== checked.length}
            loading={loading}
          >
            Continue
          </Button>
          <Button size="md" className={s.modalBodyButton} variant="secondary" onClick={() => setIsArchiveWorkflowConfirmationModalOpen(false)}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

// 480
export default ArchiveWorkflowConfirmationModal;
